import jwtDecode from 'jwt-decode'

import { LOCAL_STORAGE_KEYS } from '@constants'
import { config } from '@config'

interface Jwt {
  loginOrigin: string
}

const token = window.localStorage.getItem(LOCAL_STORAGE_KEYS.TOKEN)

const useLogout = () => {
  let decode: Jwt = { loginOrigin: '' }
  if (token) decode = jwtDecode(token)
  const samlSLO = `${config.baseURL}/auth/logout-saml?loginOrigin=${decode.loginOrigin}`
  const logout = async () => {
    window.location.assign(samlSLO)
  }

  return { logout }
}

export { useLogout }
